
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M21.157 20.975a6.798 6.798 0 1 1 0 13.597 6.798 6.798 0 0 1 0-13.597m-1.765 8.107a.7.7 0 0 0-.7.699v1.13a.7.7 0 0 0 .7.7h2.462a.7.7 0 0 0 .7-.7v-1.13a.7.7 0 0 0-.7-.7zm2.526-3.777a1.427 1.427 0 1 0 .002 2.854 1.427 1.427 0 0 0-.002-2.854M12.108 7.224V17.89h18.107V7.224zm7.04 9.231h-4.674v-7.66h4.674z","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"square","d":"M41.526 16.496V6.474a1 1 0 0 0-1-1H9.306a1 1 0 0 0-.742.33l-3.834 4.26a1 1 0 0 0-.256.669v30.793a1 1 0 0 0 1 1h35.052a1 1 0 0 0 1-1v-8.982"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"square","d":"M31.516 6.39v8.787H15.765"}}),_c('circle',{attrs:{"cx":"22.978","cy":"26.039","r":"7.032","stroke":"#234652"}}),_c('path',{attrs:{"stroke":"#234652","d":"m40.645 29.662 5.128-5.127-5.128-5.128m5.223 5.118H33.202"}})])
          )
        }
      }
    